import { useQuery } from "@apollo/client";
import type { Agent, AgentsConnection } from "@casey/db-types";
import { GET_ORGANIZATION_AGENTS } from "../gql";

interface OrganizationAgentsVariables {
  organizationId: string;
}

interface OrganizationAgentsResponse {
  agents: AgentsConnection;
}

export function useOrganizationAgents(organizationId: string) {
  const { data, loading, error, refetch } = useQuery<
    OrganizationAgentsResponse,
    OrganizationAgentsVariables
  >(GET_ORGANIZATION_AGENTS, {
    variables: { organizationId },
    skip: !organizationId,
    errorPolicy: "all",
  });

  return {
    agents: data?.agents?.nodes || [],
    loading,
    error,
    refetch,
  };
}

export type { Agent };

// Backwards compatibility
export { useOrganizationAgents as useOrganizationTemplates };
